import axios from 'axios';

export const getObservations = patientId => {
    return axios.get(`/fhir/Observation?_sort=-date&patient=${patientId}`);
};

export const getObservationsPagable = axios.get;
